import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { getUser } = useAuthStore();
  if (getUser.onboarded_at !== null && getUser.checked_policy === 1) {
    return navigateTo('/');
  }
});
